import React, { useEffect, useState } from "react";
import { supabase } from "../../services/db";
import { Link } from "react-router-dom";
import Modal from "../../components/Modal/Modal";

const ModalContent = ({ handleClose, onSubmit }) => (
  <form
    onSubmit={(event) => {
      const name = event.target.elements.name?.value;
      if (name) {
        onSubmit({ name }).then(() => handleClose());
      }
      event.preventDefault();
    }}
  >
    <div>
      <label className="Label" htmlFor="name">
        Board Name
      </label>
      <input className="Input" id="name" defaultValue="Food" />
    </div>

    <button type="submit">Submit</button>
  </form>
);

const Home = () => {
  const [boards, setBoards] = useState([]);

  useEffect(() => {
    getBoards();
  }, []);

  async function getBoards() {
    const { data } = await supabase().from("Boards").select();
    data && setBoards(data);
  }

  const addBoard = async ({ name }) => {
    await supabase().from("Boards").insert({ name });
    await getBoards();
  };

  return (
    <div className="defaultPageContainer">
      <Link to="/recipes">View all recipes</Link>
      <div className="flex">
        <h3 className="flex1">Boards</h3>
        <Modal
          title="Add Board"
          buttonContent="Add Board"
          description="Create a new board to store recipes"
          content={(handleClose) => (
            <ModalContent handleClose={handleClose} onSubmit={addBoard} />
          )}
        />
      </div>
      {boards.map((board) => (
        <Link to={`/${board.id}`} key={board.id}>
          {board.name}
        </Link>
      ))}
    </div>
  );
};
export default Home;
